import { useCallback, useState } from 'react';

import { createUrl, request } from 'app/utils';
import { Button, Flex, HelperText, Input, Modal, Typography } from 'components';
import { useSchool } from 'features/school';
import styled from 'styled-components';

import { ReactComponent as LoadingIcon } from 'app/images/loading.svg';

const Spinner = styled(LoadingIcon)`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 24px;

  circle {
    stroke: gray;
  }
`;

export const ConfirmNewEmail = () => {
  const [confirmationCode, setConfirmationCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const { apiGatewayUrl } = useSchool();

  const onClose = () => {
    window.location.href = createUrl('account');
  };

  const handleSubmit = useCallback(async () => {
    setError(null);
    setSuccess(null);

    if (!confirmationCode) {
      setError('O campo de código não pode estar vazio');
      return;
    }

    setLoading(true);

    request<{
      needToConfirmPreviousEmail: boolean;
      authenticationResult: number;
      message: string;
    }>({
      url: '/api/v1/User/ConfirmNewEmail',
      method: 'post',
      baseURL: apiGatewayUrl,
      data: {
        confirmationCode,
      },
    })
      .then(({ data }) => {
        if (data.authenticationResult === 0) {
          setSuccess('Novo e-mail confirmado! Sua conta foi atualizada.');
        } else {
          setError(data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [confirmationCode]);

  return (
    <Modal onClose={onClose}>
      <Flex flexGrow={0} width={{ d: 350 }} p={5} flexDirection="column" style={{ gap: '24px' }}>
        {success ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <Typography type="type2" fontWeight="bold" textAlign="center" style={{ textWrap: 'balance' }}>
              {success}
            </Typography>
          </div>
        ) : (
          <>
            <Typography type="type4" fontWeight="bold" textAlign="center" style={{ textWrap: 'balance' }}>
              Confirme seu novo e-mail
            </Typography>

            <div>
              <Typography type="type1" fontWeight="bold">
                Informe o código de confirmação
              </Typography>

              <div style={{ position: 'relative' }}>
                <Input
                  data-error={!!error}
                  onChange={(e) => setConfirmationCode(e.target.value)}
                  value={confirmationCode}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit();
                    }
                  }}
                />

                {loading && <Spinner />}
              </div>

              {error && <HelperText type="error">{error}</HelperText>}
            </div>

            <Button disabled={loading} type="button" onClick={handleSubmit}>
              Confirmar novo e-mail
            </Button>
          </>
        )}
      </Flex>
    </Modal>
  );
};
